<template>
  <div class="radio-button-wrapper">
    <div class="radioButton-container">
      <button-component
        :buttonLabel="$t('common.yes')"
        @toggle="toggle"
        :class="{ active: value }"
        methods="toggle"
        class="radioButton-adjust"
        data-test="yes"
      />
    </div>
    <div class="radioButton-container">
      <button-component
        :buttonLabel="$t('common.no')"
        @toggle="toggle"
        :class="{ active: !value }"
        methods="toggle"
        class="radioButton-adjust"
        data-test="no"
      />
    </div>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import ButtonComponent from "../../atoms/Button";

export default {
  props: {
    value: VueTypes.bool.isRequired
  },
  components: {
    ButtonComponent
  },
  methods: {
    toggle() {
      this.$emit("toggle");
    }
  }
};
</script>

<style scoped>
.radio-button-wrapper {
  display: flex;
}
/* ラジオボタン位置調整用 */
.radioButton-container {
  padding: 0px;
  margin-right: 20px;
}

/* ラジオボタン内部調整用 */
.radioButton-adjust {
  width: 90px;
  height: 40px;
  font-family: "HiraKakuPro-W3";
  font-size: 14px;
  margin: 10px 0px;
  padding: 10px;
}

.active {
  background-color: #c5d7ef !important;
}
</style>
